import { MENU_DEFINITION } from '../../constants'

const getMenuDefinitionBreadcrumbItemByTaskId = ({
  id,
  isCurrentViewAutoResolved,
}) => ({
  path: `/tasks/menu-definition/${id}`,
  type: MENU_DEFINITION,
  name: 'Menu Definition',
  isCurrentViewAutoResolved,
})

export default getMenuDefinitionBreadcrumbItemByTaskId
